<template>
  <div class="dispatcher-panel">
    <div class="wrapper no-scrollbar">
      <DispatcherPanelJobNew v-if="newTransactions && newTransactions.length" :transactions="newTransactions"
        @update="toggleCog" />

      <div v-if="nJobs > 1" class="toggle-btn">
        <button class="button is-white toggle" @click="toggleList">
          <i class="fa fa-chevron-down fa-lg" v-if="isTall" :key="1" />
          <i class="fa fa-chevron-up fa-lg" v-else :key="2" />
        </button>
      </div>

      <div class="header" @click="toggleCog">
        Ongoing Rides<i v-if="isUpdating" class="fa fa-spinner fa-spin fa-sm has-text-white" style="margin-left: 6px" />
        <span class="btns-wrapper">
          <i class="fa fa-chart-line" @click="dispatcherStats" />
          <i class="fa fa-info-circle" @click="dispatcherInfo" />
        </span>
      </div>

      <div class="body">
        <div v-if="nJobs">
          <DispatcherPanelJobList :isTall="isTall" />
        </div>
        <div v-else>
          <a class="bird-btn" @click="downloadSound">
            <img src="/img/home2/toucan.svg" />
          </a>
          <a ref="dl" href="/sounds/parrot.mp3" download="tuk_sound" hidden />
          <div style="padding-top: 20px; padding-bottom:20px">
            <p class="cog-wrapper" @click="toggleCog">
              <i v-if="cog" class="fa fa-cog fa-spin" />
              <i v-else class="fa fa-spinner fa-spin" />
            </p>
            <p class="subtitle is-6 has-text-grey has-text-weight-medium">
              {{ $t("driver.waiting-for-jobs") }}
            </p>
          </div>
        </div>
        <hr v-if="isTall && nJobs > 1" />
      </div>
    </div>

    <WorkflowStatsModal />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

import DispatcherPanelJobList from "@/components/DispatcherPanelJobList.vue";
import DispatcherPanelJobNew from "@/components/DispatcherPanelJobNew.vue";
import WorkflowStatsModal from "@/components/WorkflowStatsModal.vue";

export default {
  name: "DispatcherPanel",
  components: {
    DispatcherPanelJobList,
    DispatcherPanelJobNew,
    WorkflowStatsModal,
  },
  data() {
    return {
      hasNewPassenger: false, // bool for showing new passenger panel
      newTransactions: null, // transactions to show in new passenger panel
      dispatcherPollInterval: null,
      cog: false,
      isTall: false,
      acknowledged: {},
      isUpdating: false,
    };
  },
  computed: {
    nJobs() {
      // return this.$store.state.ongoingDispatcherTransactions.length;
      return this.$store.getters.getDispatcherTransactionsStateConfirmed.length;
    },
    dispatcherRole() {
      return this.$store.getters.isDispatcher;
    },
    // hasNewWorkerTransactions() {
    //   var transactions = this.$store.getters.getWorkerTransactionsStateNew;
    //   if (!transactions) return false;
    //   if (!transactions.length) return false;
    //   return true;
    // },
    hasCancelledTransactions() {
      var cancelled = this.$store.getters.getWorkerTransactionsStateCancelled;
      if (cancelled.length > 0) return true;
      return false;
    },
    // // logic could show stale driver locations to dispatcher
    //       var now = new Date();
    //       var locationUpdated = new Date(this.$store.state.userState.updated_at);
    //       var lastUpdated = (now - locationUpdated) / 1000;
    //       return lastUpdated > 120; // last updated n seconds ago
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setOngoingDispatcherTransactions") {
        if (this.hasCancelledTransactions) {
          EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
        }
        if (this.$store.getters.getDispatcherTransactionsStateNew) {
          // this.updateDriversAutocomplete(); // only for dispatcher
          this.hasNewPassenger = true;
          this.newTransactions =
            this.$store.getters.getDispatcherTransactionsStateNew;
          // EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
          setTimeout(() => EventBus.$emit("DRIVER_FIT_LAYER"), 600);
        } else {
          this.hasNewPassenger = false;
        }
      }
    });
  },
  mounted() {
    EventBus.$on("OPEN_PASSENGER_DETAIL", () => this.toggleList("short"));

    EventBus.$on("DISPATCHER_LOADER", (on) => {
      if (on) this.isUpdating = true;
      else this.isUpdating = false;
    });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") return;
      this.updateOrdersFleetDispatcher();
    });
    this.pollTransactions();
  },
  activated() {
    this.updateOrdersFleetDispatcher();
  },
  beforeDestroy() {
    if (this.dispatcherPollInterval) clearInterval(this.dispatcherPollInterval);
  },
  methods: {
    dispatcherStats() {
      var r = this.dispatcherRole;
      this.displayModal(".workflow-stats-modal");
      EventBus.$emit("WORKFLOW_STATS", r.workflow_id);
    },
    dispatcherInfo() {
      this.infoToast(this.dispatcherRole.business.name, "top");
    },
    toggleCog() {
      // if (this.cog) sounds("collect2");
      // else sounds("success");
      this.cog = !this.cog;
      this.updateOrdersFleetDispatcher();
    },
    pollTransactions() {
      if (this.dispatcherPollInterval) return; // don't do if already set up
      this.dispatcherPollInterval = setInterval(() => {
        this.updateOrdersFleetDispatcher();
      }, 1000 * 30); // ping ever 10 seconds
    },
    toggleList(size) {
      this.toggleCog();
      if (size === "short") {
        this.isTall = false;
      } else {
        this.isTall = !this.isTall;
      }
    },
    downloadSound() {
      sounds("parrot");
      var title = this.$t("squawk.title");
      var steps = this.$t("squawk.steps");
      var step1 = this.$t("squawk.1");
      var step2 = this.$t("squawk.2");
      var step3 = this.$t("squawk.3");
      var download = this.$t("squawk.download");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.3em'>
        <i class='fab fa-earlybirds'></i>&nbsp;${title}
        </p>
        <p style='margin-bottom:12px'><i>${steps}</i></p>
        <p>1. <i class='fa fa-download'></i>&nbsp;${step1}</p>
        <p>2. <i class='fa fa-folder-plus'></i>&nbsp;${step2}</p>
        <p>3. <i class='fa fa-cog'></i>&nbsp;${step3}</p></div>`,
        showCloseButton: true,
        confirmButtonText: `${download}&nbsp;<i class='fa fa-download'></i>`,
      }).then((val) => {
        if (val.value) {
          this.$refs.dl.click();
          var loader = this.loadingDots("cyan");
          setTimeout(() => {
            loader.hide();
            this.$swal({
              title: this.$t("success"),
              text: "tuk_sound.mp3 saved to downloads folder",
              showConfirmButton: false,
              showCloseButton: true,
              type: "success",
              timer: 6000,
            });
          }, 500);
        }
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 180px;
  max-height: calc(100vh - 150px);
  /* overflow: scroll; */
  width: 100%;
}

.header {
  text-align: left;
  font-size: 1.4em;
  padding: 6px 10px;
  background-color: #ddd;
  text-shadow: 0px 0px 2px #fff;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.3);
}

.btns-wrapper {
  float: right;
  padding: 2px;
  color: grey;
}

.btns-wrapper .fa {
  padding-left: 18px;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(247, 211, 8, 0.5);
  }
}

.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 50%;
}

.pulse-blue {
  animation: shadow-pulse-blue 1s infinite;
}

@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255, 0.95);
  }

  100% {
    box-shadow: 0 0 0 5px rgba(0, 255, 255, 0.5);
  }
}

.toggle {
  padding: 8px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  /* filter: drop-shadow(2px 2px 2px #666); */
}

.badge {
  z-index: 1;
  position: absolute;
  margin-top: -2px;
  margin-left: -8px;
  background-color: #ff3860 !important;
  border-radius: 50%;
  padding: 6px;
}

@keyframes pulse-text {
  0% {
    text-shadow: 0 0 0 yellow;
  }

  50% {
    text-shadow: 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow, 0 0 14px yellow,
      0 0 14px yellow, 0 0 14px yellow, 0 0 14px black;
  }

  100% {
    text-shadow: 0 0 0 yellow;
  }
}

.bird-btn {
  position: absolute;
  right: 25px;
  margin-top: 35px;
  padding: 12px 9px;
  /* background-color: rgba(255, 255, 255, 0); */
}

.bird-btn img {
  height: 35px;
  opacity: 0.5;
}

.toggle-btn {
  height: 0px;
  position: relative;
  top: 3px;
  /* top: -40px; */
}

.link {
  border-bottom: 1px #ccc dotted;
}

hr {
  margin: 0 0;
  border: 5px solid lightgrey;
}

.stale-warning {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 192, 203, 0.5);
  z-index: 23;
}

.stale-btn {
  padding: 12px;
  background-color: red;
  color: white;
  /* margin: auto; */
  width: 50vw;
  top: 50vh;
  position: absolute;
  transform: translate(50%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}

.bg-green {
  background-color: lightgreen;
}

.cog-wrapper {
  padding-top: 15px;
  font-size: 3em;
  color: #bbb;
}

.height-auto {
  height: auto;
}
</style>